import '@fontsource/fredoka/500.css';
import '@fontsource/fredoka/600.css';
import '@fontsource/fredoka/700.css';
import { Stage } from './render/stage';
import { loadAssets } from './assets/loader';
import { App } from './app';
import { sound } from './audio/sound';
import { loadSettings } from './settings';
import { loadCustomLevel } from './levels';
import { Text, type Container } from 'pixi.js';

async function boot(): Promise<void> {
  const bootEl = document.getElementById('boot')!;
  loadSettings();
  // browsers (esp. iOS) only allow audio after a touch: unlock on every early touch
  for (const ev of ['pointerdown', 'touchend'] as const) window.addEventListener(ev, () => sound.unlock(), { passive: true });
  // text is rasterised by Pixi, so the font must be ready first
  await Promise.all(['500', '600', '700'].map((w) => document.fonts.load(`${w} 32px Fredoka`)));
  const stage = new Stage();
  await stage.init(document.getElementById('app')!);
  await loadAssets((p) => (bootEl.textContent = `Loading… ${Math.round(p * 100)}%`));
  bootEl.classList.add('hidden');
  // ?level=N plays level N, ?custom=1 the level from the editor, ?reset=1 starts over, ?debug=1 opens everything
  const params = new URLSearchParams(window.location.search);
  const custom = params.has('custom') ? loadCustomLevel() : undefined;
  new App(stage, params.has('debug')).start(params, custom);
  // test helper: screen position of a visible text, e.g. cafePawsFind('Continue')
  (window as unknown as { cafePawsFind: unknown }).cafePawsFind = (text: string) => {
    const shown = (c: Container | null): boolean => !c || (c.visible && c.alpha > 0.5 && shown(c.parent));
    const walk = (c: Container): Text | undefined => {
      if (c instanceof Text && c.text === text && shown(c)) return c;
      for (const ch of c.children) {
        const hit = walk(ch as Container);
        if (hit) return hit;
      }
      return undefined;
    };
    const t = walk(stage.app.stage);
    return t ? t.getGlobalPosition() : null;
  };
}

boot().catch((err) => {
  console.error(err);
  document.getElementById('boot')!.textContent = 'Something went wrong. Please reload.';
});
